import { useEffect, useState } from 'react';
import { delayUntilIdle } from './delayUntilIdle';
export const useIsIdle = () => {
  const [isIdle, setIsIdle] = useState(false);
  useEffect(() => {
    delayUntilIdle(() => setIsIdle(true));
  }, []);
  return isIdle;
};